import react from 'react'
import ColorButton from '../../Buttons/ColorButton'
import { Box, Alert } from '@mui/material'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid';

const executeScript = async (id, apiRef, rootProps) => {

    const res = await api.post(`/scripts/${id}/execute/`)
    if (res.status === 200) {
        toast.success(`A execução foi iniciada. Aguarde alguns instantes.`)
    } 

    apiRef.close()
}

const FunctionComponent = ({ data }) => {

    const apiRef = useGridApiContext()
    const rootProps = useGridRootProps()

    return (
        <Box sx={{ padding: '.5rem', display: 'flex', flexDirection: 'column', gap: '.5rem', maxWidth: '30rem' }} >
            <Alert>Clique no botão para executar a função selecionada. Não é possível fazer mais requisições se já houver alguma em andamento em sua empresa.</Alert>
            {data.map(func => (
                <ColorButton onClick={() => { executeScript(func.id, apiRef, rootProps) }} >{func.name}</ColorButton>
            ))}
        </Box>
    )
}

export default FunctionComponent